import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, type CanActivateFn } from '@angular/router';
import { AuthenticationService } from '@app/core/auth';

export const preventLoggedInGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthenticationService);
   if (authService.isLoggedIn()) {
    const returnUrl = route.queryParamMap.get('returnUrl');
    const urlDeRedireccion = returnUrl || '/home';
    return router.parseUrl(urlDeRedireccion);
  }

  return true;
};
